/*
 * ALONE HABIB — Carrousel des grilles produits
 * Glissement horizontal tactile
 * Blocage du scroll vertical pendant le swipe horizontal
 * Flèches, clavier et variantes de couleur conservés
 */

(function () {
  "use strict";

  const SELECTOR = ".ah-grid-carousel";
  const SLIDE = ".ah-grid-carousel__slide";
  const DURATION = 300;

  function getCarousel(element) {
    return element && element.closest
      ? element.closest(SELECTOR)
      : null;
  }

  function getSlides(carousel) {
    return Array.from(carousel.querySelectorAll(SLIDE));
  }

  function getIndex(carousel) {
    return Number(carousel.dataset.ahIndex || 0);
  }

  function normalize(index, count) {
    return ((index % count) + count) % count;
  }

  function getWidth(carousel) {
    const container = carousel.querySelector(
      ".ah-grid-carousel__slides"
    );

    return (
      (container && container.clientWidth) ||
      carousel.clientWidth ||
      1
    );
  }

  function updateDots(carousel, index) {
    carousel
      .querySelectorAll(".ah-grid-carousel__dot")
      .forEach(function (dot, position) {
        dot.classList.toggle(
          "is-active",
          position === index
        );
      });
  }

  function setPosition(slide, position, animate) {
    slide.style.transition = animate
      ? "transform " + DURATION + "ms ease"
      : "none";

    slide.style.transform =
      "translate3d(" + position + "px, 0, 0)";
  }

  function positionSlides(carousel, offset, animate) {
    const slides = getSlides(carousel);
    const count = slides.length;
    const index = getIndex(carousel);
    const width = getWidth(carousel);

    if (!count) return;

    slides.forEach(function (slide, position) {
      let distance = position - index;

      if (distance > count / 2) {
        distance -= count;
      }

      if (distance < -count / 2) {
        distance += count;
      }

      if (count === 2 && position !== index) {
        distance = offset > 0 ? -1 : 1;
      }

      setPosition(
        slide,
        distance * width + offset,
        animate
      );

      const active = position === index;

      slide.classList.toggle("is-active", active);

      slide.setAttribute(
        "aria-hidden",
        active ? "false" : "true"
      );

      slide.style.pointerEvents = active
        ? "auto"
        : "none";
    });

    updateDots(carousel, index);
  }

  function finishMove(carousel, direction) {
    const slides = getSlides(carousel);
    const count = slides.length;

    if (count < 2) return;

    const oldIndex = getIndex(carousel);
    const newIndex = normalize(
      oldIndex + direction,
      count
    );

    const width = getWidth(carousel);

    const oldSlide = slides[oldIndex];
    const newSlide = slides[newIndex];

    const targetOld = direction > 0
      ? -width
      : width;

    slides.forEach(function (slide, position) {
      if (
        position !== oldIndex &&
        position !== newIndex
      ) {
        slide.style.transition = "none";
      }
    });

    setPosition(oldSlide, targetOld, true);
    setPosition(newSlide, 0, true);

    carousel.dataset.ahIndex = String(newIndex);

    updateDots(carousel, newIndex);

    slides.forEach(function (slide, position) {
      const active = position === newIndex;

      slide.classList.toggle("is-active", active);

      slide.setAttribute(
        "aria-hidden",
        active ? "false" : "true"
      );

      slide.style.pointerEvents = active
        ? "auto"
        : "none";
    });

    clearTimeout(carousel.ahResetTimer);

    carousel.ahResetTimer = setTimeout(function () {
      positionSlides(carousel, 0, false);
      carousel.dataset.ahAnimating = "false";
    }, DURATION + 40);
  }

  function changeSlide(carousel, direction) {
    if (!carousel) return;

    if (carousel.dataset.ahAnimating === "true") {
      return;
    }

    const slides = getSlides(carousel);

    if (slides.length < 2) return;

    carousel.dataset.ahAnimating = "true";

    const index = getIndex(carousel);
    const nextIndex = normalize(
      index + direction,
      slides.length
    );

    const width = getWidth(carousel);

    slides.forEach(function (slide, position) {
      if (position === index) {
        setPosition(slide, 0, false);
      } else if (position === nextIndex) {
        setPosition(
          slide,
          direction > 0 ? width : -width,
          false
        );
      }
    });

    void carousel.offsetWidth;

    finishMove(carousel, direction);
  }

  function showSlide(carousel, requestedIndex) {
    const slides = getSlides(carousel);

    if (!slides.length) return;

    const target = normalize(
      requestedIndex,
      slides.length
    );

    carousel.dataset.ahIndex = String(target);

    positionSlides(carousel, 0, false);
  }

  function initialize(carousel) {
    if (carousel.dataset.ahInitialized === "true") {
      return;
    }

    if (getSlides(carousel).length < 2) {
      return;
    }

    carousel.dataset.ahInitialized = "true";
    carousel.dataset.ahIndex = "0";
    carousel.dataset.ahAnimating = "false";

    positionSlides(carousel, 0, false);
  }

  function initializeAll(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.matches(SELECTOR)) {
      initialize(root);
    }

    root.querySelectorAll(SELECTOR).forEach(initialize);
  }

  /*
   * VARIANTES DE COULEUR
   */

  function selectColor(swatch) {
    const card = swatch.closest(".grid-item");

    if (!card) return false;

    const carousel = card.querySelector(SELECTOR);

    if (!carousel) return false;

    const imageUrl = swatch.getAttribute(
      "data-variant-image"
    );

    if (!imageUrl) return false;

    const slides = getSlides(carousel);

    if (!slides.length) return false;

    const targetUrl = new URL(
      imageUrl,
      window.location.href
    );

    const targetPath = targetUrl.pathname;

    let matchingIndex = -1;

    slides.forEach(function (slide, index) {
      const image = slide.querySelector("img");

      if (!image || matchingIndex !== -1) return;

      const candidates = [
        image.currentSrc,
        image.getAttribute("src"),
        image.getAttribute("data-src")
      ].filter(Boolean);

      const match = candidates.some(function (candidate) {
        try {
          const candidateUrl = new URL(
            candidate,
            window.location.href
          );

          const normalizePath = function (path) {
            return path.replace(
              /_(\d+x\d*|x\d+)(?=\.[^.]+$)/g,
              ""
            );
          };

          return (
            normalizePath(candidateUrl.pathname) ===
            normalizePath(targetPath)
          );
        } catch (error) {
          return false;
        }
      });

      if (match) matchingIndex = index;
    });

    if (matchingIndex >= 0) {
      showSlide(carousel, matchingIndex);
    } else {
      const firstSlide = slides[0];
      const image = firstSlide.querySelector("img");

      if (!image) return false;

      if (!image.dataset.ahOriginalSrc) {
        image.dataset.ahOriginalSrc =
          image.getAttribute("src") || "";

        image.dataset.ahOriginalSrcset =
          image.getAttribute("srcset") || "";
      }

      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.setAttribute("src", imageUrl);

      showSlide(carousel, 0);
    }

    card
      .querySelectorAll(
        ".grid-product__colors .color-swatch"
      )
      .forEach(function (item) {
        item.classList.toggle(
          "is-active",
          item === swatch
        );
      });

    return true;
  }

  /*
   * FLÈCHES SUR ORDINATEUR
   */

  document.addEventListener(
    "pointerdown",
    function (event) {
      if (!(event.target instanceof Element)) return;

      if (
        event.target.closest(
          ".ah-grid-carousel__arrow"
        )
      ) {
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      if (!(event.target instanceof Element)) return;

      const arrow = event.target.closest(
        ".ah-grid-carousel__arrow"
      );

      if (!arrow) return;

      const carousel = getCarousel(arrow);

      if (!carousel) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      changeSlide(
        carousel,
        arrow.classList.contains(
          "ah-grid-carousel__arrow--next"
        )
          ? 1
          : -1
      );
    },
    true
  );

  /*
   * VARIANTES COULEUR
   */

  document.addEventListener(
    "click",
    function (event) {
      if (!(event.target instanceof Element)) return;

      const swatch = event.target.closest(
        ".grid-product__colors .color-swatch[data-variant-image]"
      );

      if (!swatch) return;

      const card = swatch.closest(".grid-item");

      if (
        !card ||
        !card.querySelector(SELECTOR)
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      selectColor(swatch);
    },
    true
  );

  /*
   * NAVIGATION AU CLAVIER
   */

  document.addEventListener(
    "keydown",
    function (event) {
      if (!(event.target instanceof Element)) return;

      const arrow = event.target.closest(
        ".ah-grid-carousel__arrow"
      );

      if (!arrow) return;

      if (
        event.key !== "Enter" &&
        event.key !== " "
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      const carousel = getCarousel(arrow);

      if (!carousel) return;

      changeSlide(
        carousel,
        arrow.classList.contains(
          "ah-grid-carousel__arrow--next"
        )
          ? 1
          : -1
      );
    },
    true
  );

  /*
   * NAVIGATION TACTILE MOBILE
   *
   * Correction :
   * - Swipe horizontal : blocage du scroll vertical.
   * - Geste vertical : défilement normal de la page.
   */

  let gesture = null;
  let suppressClickUntil = 0;

  document.addEventListener(
    "touchstart",
    function (event) {
      gesture = null;

      if (
        event.touches.length !== 1 ||
        !(event.target instanceof Element)
      ) {
        return;
      }

      const carousel = getCarousel(event.target);

      if (!carousel) return;

      if (getSlides(carousel).length < 2) return;

      if (
        carousel.dataset.ahAnimating === "true"
      ) {
        return;
      }

      gesture = {
        carousel: carousel,
        startX: event.touches[0].clientX,
        startY: event.touches[0].clientY,
        lastX: event.touches[0].clientX,
        axis: null
      };
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    "touchmove",
    function (event) {
      if (!gesture) return;

      if (event.touches.length !== 1) return;

      const dx =
        event.touches[0].clientX -
        gesture.startX;

      const dy =
        event.touches[0].clientY -
        gesture.startY;

      /*
       * Détection de la direction du geste.
       */

      if (
        !gesture.axis &&
        (Math.abs(dx) > 7 || Math.abs(dy) > 7)
      ) {
        gesture.axis =
          Math.abs(dx) > Math.abs(dy) * 1.2
            ? "x"
            : "y";
      }

      /*
       * Si le geste est vertical,
       * on laisse Safari faire défiler la page.
       */

      if (gesture.axis === "y") {
        return;
      }

      /*
       * Si le geste est horizontal,
       * on empêche le déplacement de la page.
       */

      if (gesture.axis === "x") {
        if (event.cancelable) {
          event.preventDefault();
        }

        gesture.lastX =
          event.touches[0].clientX;

        gesture.carousel.dataset.ahDragging = "true";

        positionSlides(
          gesture.carousel,
          dx,
          false
        );
      }
    },
    {
      passive: false,
      capture: true
    }
  );

  document.addEventListener(
    "touchend",
    function (event) {
      if (!gesture) return;

      const current = gesture;
      gesture = null;

      if (current.axis !== "x") return;

      const carousel = current.carousel;

      const endX = event.changedTouches.length
        ? event.changedTouches[0].clientX
        : current.lastX;

      const dx = endX - current.startX;

      delete carousel.dataset.ahDragging;

      const width = getWidth(carousel);

      const threshold = Math.max(
        30,
        Math.min(65, width * 0.18)
      );

      suppressClickUntil = Date.now() + 650;

      if (Math.abs(dx) > threshold) {
        carousel.dataset.ahAnimating = "true";

        /*
         * La photo continue depuis sa position
         * actuelle, sans saut au relâchement.
         */

        finishMove(
          carousel,
          dx < 0 ? 1 : -1
        );
      } else {
        positionSlides(
          carousel,
          0,
          true
        );
      }
    },
    {
      passive: true,
      capture: true
    }
  );

  document.addEventListener(
    "touchcancel",
    function () {
      if (!gesture) return;

      const carousel = gesture.carousel;

      gesture = null;

      delete carousel.dataset.ahDragging;

      positionSlides(carousel, 0, true);
    },
    {
      passive: true,
      capture: true
    }
  );

  /*
   * Empêche l'ouverture accidentelle
   * d'une fiche produit après un swipe.
   */

  document.addEventListener(
    "click",
    function (event) {
      if (Date.now() > suppressClickUntil) {
        return;
      }

      if (!(event.target instanceof Element)) {
        return;
      }

      if (getCarousel(event.target)) {
        event.preventDefault();
        event.stopImmediatePropagation();

        suppressClickUntil = 0;
      }
    },
    true
  );

  /*
   * INITIALISATION
   */

  function start() {
    initializeAll(document.documentElement);

    const observer = new MutationObserver(
      function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(
            function (node) {
              if (node.nodeType === 1) {
                initializeAll(node);
              }
            }
          );
        });
      }
    );

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start
    );
  } else {
    start();
  }

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initializeAll(event.target);
    }
  );
})();

